export default "__VITE_ASSET__Byi2sphV__"